<div #mainBox [class.top-box]="isTopBox" [class.bottom-box]="isBottomBox" class="fluencyrate-box pointer"
    (clickOutside)="onClickOutside()" [additionalElementRefs]="extraBoxes">
    <div class="flag flex-column  no-select" [class.flag-all-trials]="remainingTrials<=0" (mousedown)="startLongPress()" (mouseup)="endLongPress($event)"
        (mouseleave)="endLongPress($event)" (touchstart)="startLongPress()" (touchend)="endLongPress($event)"
        (touchcancel)="endLongPress($event)" (click)="clickedBox()" >

        <div class="duration-container" [class.blinking-effect]="isAlarmRinging">
            <div class="duration-controls">
                <input *ngIf="!isStarted"class="duration-button start-button" style="outline: none;"  [(ngModel)]="timerValueInput" (ngModelChange)="changedTimerValue()" (input)="onInputChange($event)" />
                <button *ngIf="!isStarted" (click)="startTimer()" class="duration-button start-button">start</button>
                <button *ngIf="isStarted"  class="duration-button start-button">{{timerString()}}</button>
                <button *ngIf="isStarted" (click)="stopTimer()" class="duration-button stop-button">
                    Stop
                </button>
            </div>
            
            <div class="flag-text">{{ text }}
                
            <span class="sd-text">{{target?.DiscriminativeStimulus}}</span>
            </div>
        </div>
        <span class="badge-count" (click)="showExtra2()" [class.badge-count-green]="toiletings.length>=expectedAmount"
            [class.badge-count-red]="toiletings.length<expectedAmount">{{toiletings.length}}/{{expectedAmount}}</span>

        <button class="badge-bottom-left" [class.target-note-new]="target?.HasUnreadTargetNoteForStaff" (click)="openDetails($event)" >?</button>
        <button class="badge-bottom-right" (click)="openDetails($event)" title="Remaining desired Trials" *ngIf="remainingTrials>0"> {{remainingTrials}}</button>  
    </div>
</div>
@if (detailsOpened) {
<app-target-details [target]="target" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
}

<div class="extra-container" #extraBox [class.hide]="!extraOpened">
    <div class="extra-container-textbox">
        <div class="score-buttons align-items-start ">
            <span class="m-2"><p-checkbox inputId="urination-on" [(ngModel)]="UrinationOn" [binary]="true" (onChange)="setUrinationOn($event)"></p-checkbox><label for="urination-on" class="ml-2">Urination On</label></span>
            <span class="m-2"><p-checkbox inputId="urination-off" [(ngModel)]="UrinationOff" [binary]="true" (onChange)="setUrinationOff($event)"></p-checkbox><label for="urination-off" class="ml-2">Urination Off</label></span>
            <span class="m-2"><p-checkbox inputId="bowel-on" [(ngModel)]="BowelMovementOn" [binary]="true" (onChange)="setBowelMovementOn($event)"></p-checkbox><label for="bowel-on" class="ml-2">Bowel On</label></span>
            <span class="m-2"><p-checkbox inputId="bowel-off" [(ngModel)]="BowelMovementOff" [binary]="true" (onChange)="setBowelMovementOff($event)"></p-checkbox><label for="bowel-off" class="ml-2">Bowel Off</label></span>
            <span class="m-2"><p-checkbox inputId="no-void" [(ngModel)]="NoVoid" [binary]="true" (onChange)="setNoVoid($event)"></p-checkbox><label for="no-void" class="ml-2">No Void</label></span>
        </div>
    </div>
</div>

<div class="extra-container" #extraBox2 [class.hide]="!extra2Opened">
    <div class="extra-close" (click)="closeExtra2()">X</div>
    <div class="extra-container-textbox">
        <div *ngFor="let toileting of toiletings">
            <div class="float-right extra-list-trash-icon pointer" (click)="deleteData(toileting)"><i class="pi pi-trash"></i></div>
            <div>{{ toileting.FormattedDate }}</div>
            <div [innerHTML]="getToiletingText(toileting)"></div>
        </div>
    </div>
</div>
